import { type AppApi, type EDITOR_TYPE } from '@wix/wix-data-client-common'
import getPanelUrl from '@wix/wix-data-client-common/dist/esm/panels/getPanelUrl'
import { dynamicEditPagePanel as dynamicEditPagePanelDef } from '@wix/wix-data-client-common/dist/esm/panels/panelDefs'
import { type EditorSDK } from '@wix/wix-data-client-common-standalone'
import { DIMENSIONS, DYNAMIC_EDIT_PAGE_PANEL_ACTIONS } from './consts'
import { panelName } from './bi/consts'
import type { Permissions } from '@wix/wix-data-schema-types'

interface PanelOpenerProps {
  appApi: AppApi
  collectionId: string
  collectionName?: string
  permissions?: Permissions
  isFirstTimeExperience: boolean
  editorSdkProxy: EditorSDK
  editorType: EDITOR_TYPE
  hostname: string
  origin: string
}

export const openPanel = async ({
  appApi,
  collectionId,
  collectionName,
  permissions,
  isFirstTimeExperience,
  editorSdkProxy,
  editorType,
  hostname,
  origin,
}: PanelOpenerProps) => {
  const panelResult = await editorSdkProxy.editor.openModalPanel({
    url: await getPanelUrl({
      editorSdkProxy,
      hostname,
      relativeUrl: dynamicEditPagePanelDef.url,
    }),
    width: DIMENSIONS.width,
    height: DIMENSIONS.height,
    shouldHideHeader: true,
    initialData: {
      collectionId,
      collectionName,
      permissions,
      editorType,
      origin,
    },
  })

  if (!panelResult) {
    return
  }

  const { type } = panelResult

  switch (type) {
    case DYNAMIC_EDIT_PAGE_PANEL_ACTIONS.OPEN_ADD_DYNAMIC_PAGE_PANEL:
      return appApi.openAddDynamicPagePanelV5({
        origin,
        collectionId,
        isFirstTimeExperience,
      })

    case DYNAMIC_EDIT_PAGE_PANEL_ACTIONS.ADD_DYNAMIC_EDIT_PAGE:
      return appApi.addDynamicEditPage({
        collectionId,
        origin,
        panelName,
      })
  }

  return
}
